// document.addEventListener("DOMContentLoaded", function () {
//     const button = document.querySelector(".studies-say__button");
//     const blocks = document.querySelector(".studies-say__blocks");
//     button.addEventListener('click', () => {
//         button.classList.add('hidden')
//         blocks.classList.add('view-all')
//     })
// });